// extracted by mini-css-extract-plugin
export default {"wrapper":"EntryCard_wrapper__z2AHG","footer":"EntryCard_footer__jMiEp"};